<template>
    <b-modal ref="notificationModal"
             size="lg"
             :title="modalTitle"
             :header-bg-variant="headerBg"
             :header-text-variant="headerText"
             centered>
        <div class="d-block">
            <span v-html="modalText"></span>
        </div>
        <template slot="modal-footer" slot-scope="{ ok }">
            <b-button size="sm" variant="success" @click="ok()">
                <i class="fas fa-check"></i> Értettem
            </b-button>
        </template>
    </b-modal>
</template>

<script>
    export default {
        name: "NotificationModal",
        props: {
            modalTitle: {type: String},
            headerBg: {type: String, default: 'warning'},
            headerText: {type: String, default: 'dark'},
            modalText: {type: String}
        },
        methods: {
            showDialog() {
                this.$refs['notificationModal'].show()
            },
        }
    }
</script>

<style scoped>

</style>
